import Box from "@mui/material/Box"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import Grid from "@mui/material/Grid"
import Tooltip from "@mui/material/Tooltip"
import { AutoField, useField } from "@w3rone/json-schema-form"
import type { FieldComponentProps } from "@w3rone/json-schema-form"
import { DateFieldPropProvider } from "./DateField"
import { FormErrors } from "./FormErrors"
import Info from "@mui/icons-material/Info"
import * as v from "valibot"

export const DateIntervalField = ({ name }: FieldComponentProps) => {
  const { value, errors, label, description } = useField(name)

  assertDateIntervalValue(value)

  return (
    <FormControl
      variant="standard"
      component="fieldset"
      error={errors.length > 0}
      fullWidth={true}
    >
      {label ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <FormLabel component="legend">{label}</FormLabel>
          {description ? (
            <Tooltip
              title={<div dangerouslySetInnerHTML={{ __html: description }} />}
            >
              <Info />
            </Tooltip>
          ) : null}
        </Box>
      ) : null}
      <FormErrors errors={errors} />
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <DateFieldPropProvider
            maxDate={value?.to ? new Date(value.to) : undefined}
          >
            <AutoField name={`${name}[from]`} />
          </DateFieldPropProvider>
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <DateFieldPropProvider
            minDate={value?.from ? new Date(value.from) : undefined}
          >
            <AutoField name={`${name}[to]`} />
          </DateFieldPropProvider>
        </Grid>
      </Grid>
    </FormControl>
  )
}

const DateIntervalValueSchema = v.object({
  from: v.optional(v.string()),
  to: v.optional(v.string()),
})

type DateIntervalValue = v.InferOutput<typeof DateIntervalValueSchema>

function assertDateIntervalValue(
  value: unknown,
): asserts value is DateIntervalValue | undefined {
  if (value === undefined) return
  v.parse(DateIntervalValueSchema, value)
}
